export const heroImages = [
  { src: '/media/img01.jpg', alt: '천안GF골프연습장 시설 1' },
  { src: '/media/img02.jpg', alt: '천안GF골프연습장 시설 2' },
];

export const logoUrl = '/media/img03.jpg';

export const galleryImages = [
  { src: '/media/img04.jpg', alt: '휴게실' },
  { src: '/media/img05.jpg', alt: '휴게실 정면' },
  { src: '/media/img06.jpg', alt: '연습타석' },
  { src: '/media/img07.jpg', alt: '외부촬영사진' },
  { src: '/media/img08.jpg', alt: '1:1 집중레슨 룸' },
  { src: '/media/img09.jpg', alt: '연습타석2' },
  { src: '/media/img10.jpg', alt: '1:1 집중레슨룸(1)' },
  { src: '/media/img11.jpg', alt: '키오스크' },
];

export const facilityImages = [
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/KakaoTalk_20221109_092135026_17-1024x683.jpg', alt: '층별안내' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/데스크-1024x683.jpg', alt: '데스크' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/키오스크-1024x683.jpg', alt: 'KIOSK' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/타석-1024x683.jpg', alt: '타석전경' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/6F프라이빗-1024x683.jpg', alt: '6F Private' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/6F트랙맨-휴게-1024x683.jpg', alt: 'VVIP Room' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/프라이빗1-1024x682.jpg', alt: '7층 Private Room' },
];

export const amenityImages = [
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/퍼팅장-1024x683.jpg', alt: '퍼팅장' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/6F휴게-1024x683.jpg', alt: '휴게공간' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/타석휴게-1024x683.jpg', alt: '타석휴게공간' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/통로1-1024x682.jpg', alt: '6층통로대기석' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/통로사진-1-1024x683.jpg', alt: '타석대기공간' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/라커2-1024x683.jpg', alt: '라커룸' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/클럽-세척대-1024x683.jpg', alt: '클럽세척대' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/측정1-1024x683.jpg', alt: 'Fitting room 측정기2' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/측정2-1024x683.jpg', alt: 'Fitting Room 측정기' },
];

export const lessonImages = [
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/KakaoTalk_20221115_172059881_06-1024x683.jpg', alt: '기본레슨', title: '기본레슨', desc: '타석에서 진행되는 1:1 맞춤레슨' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/KakaoTalk_20221109_092223544_24-1024x683.jpg', alt: '1:1 집중 프라이빗레슨', title: '1:1 집중 프라이빗레슨', desc: '프라이빗 룸에서 진행되는 EYE XO 와 트랙맨을 이용한 1:1 집중레슨' },
  { src: 'http://cwga.co.kr/wp-content/uploads/2022/11/필드레슨과정-1024x682.jpg', alt: '필드레슨', title: '필드레슨', desc: '코스에서 진행되는 실전필드레슨' },
];

export const lessonProgramImage = 'http://cwga.co.kr/wp-content/uploads/2022/11/레슨프로그램소개-1024x745.jpg';

export const pros = [
  {
    name: '윤혜민 프로',
    role: 'HEAD PRO',
    image: '/media/img12.jpg',
    careers: [
      'KPGA(한국프로 골프협회) PRO',
      '이포고등학교 골프과 졸업',
      'SKY72 드림골프 레인지',
      '골프포트',
    ],
  },
];

export const amenities = [
  '편리한주차장',
  '넓은휴게공간',
  '야회퍼팅연습장',
  '야외벙커연습장',
  '클럽세척공간',
  '락커룸',
];

export const coreValuesImage = 'http://cwga.co.kr/wp-content/uploads/2022/11/청원-정신.png';